import client from "./client";

export const generateMyAvatar = () => client.post("/me/avatar").then((r) => r.data);
